import React from 'react'
import _ from "lodash";
import { colorList } from 'utils/colors'
import FontAwesome5 from '@expo/vector-icons/FontAwesome5'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { FA5Style } from '@expo/vector-icons/build/FontAwesome5';
import { StyleSheet, View } from 'react-native'
import ThemedBadge from "components/atoms/ThemedBadge";


/*---------------------------------
    More 'complex' icons
*/

export const IconPlaceHolder = ( props = {} ) => {
	return (
		() => {
			props = createProps( props );

			const size =  _.get( props, 'size', 18 );

			const style = {
				...props[ 'style' ],
				width: size,
				height: size
			};

			return <View style={ style } />;
		}
	);
}
export const IconPlaceHolderComponent = ( props = {} ) => {
	return IconPlaceHolder(props)();
}


// Status icon
export const IconStatus = ( props = {} ) => {
	return (
		() => {
			let iconName = _.get( props, 'checked', false ) ? 'circle' : 'circle'; // checked equals read
			let style = _.get( props, 'checked', false ) ? FA5Style.solid : FA5Style.regular;

			return renderFontAwesomeIcon( iconName, props, style );
		}
	);
}
export const IconStatusComponent = ( props = {}  ) => {
	return IconStatus(props)();
}


// Envelope icon
export const IconEnvelope = ( props = {} ) => {
	return (
		() => {
			let iconName    = _.get( props, 'checked', false ) ? 'envelope-open-text' : 'envelope' ; // checked equals read
			let style       = _.get( props, 'checked', false ) ? FA5Style.solid : FA5Style.regular;

			return renderFontAwesomeIcon( iconName , props, style);
		}
	);
}
export const IconEnvelopeComponent = ( props = {} ) => {
	return IconEnvelope(props)();
}


// Favourite icon
export const IconFavourite = ( props = {} ) => {
	return (
		() => {
			let faStyle = FA5Style.regular;
			if( _.get( props, 'checked', false ) ){
				faStyle = FA5Style.solid;
			}
			return renderFontAwesomeIcon( 'heart' , props, faStyle );
		}
	);
}
export const IconFavouriteComponent = ( props = {} ) => {
	return IconFavourite(props)();
}


export const IconFlash = ( props = {} ) => {
	return (
		() => {
			let name = 'flash-off';
			if( _.get( props, 'flashOn', false ) ){
				name = 'flash';
			}
			return renderMaterialCommunityIcon( name , props );
		}
	);
}
export const IconFlashComponent = ( props = {} ) => {
	return IconFlash(props)();
}

/*
// Flashlight icon
export const IconFlash = ( props = {} ) => () => { return renderMaterialCommunityIcon( 'flash', props ); }
export const IconFlashComponent = ( props = {} ) => {return IconFlash( props )(); }

export const IconFlashOff = ( props = {} ) => () => { return renderMaterialCommunityIcon( 'flash-off', props ); }
export const IconFlashOffComponent = ( props = {} ) => {return IconFlashOff( props )(); }

 */

// Checkbox icon
export const IconCheckbox = ( props = {} ) => {
	return (
		() => {
			let iconName = _.get( props, 'checked', false ) ? 'check-square' : 'square';
			return renderFontAwesomeIcon( iconName , props );
		}
	);
}
export const IconCheckboxComponent = ( props = {} ) => {
	return IconCheckbox(props)();
}

const createProps = ( props = {} ) => {
	let createdProps = { ...props };
	const callerStyle = StyleSheet.flatten( props.style ) ?? {};
	
	const size =  _.get( props, 'size', 18 );
	const color = _.get( props, 'color', _.get( callerStyle, 'color', _.get( props, 'fill', colorList.BLACK.primary ) ) );
	
	// create the proper style properties
	const style = {
		fontSize: size,
		color: color,
		
		flex: 0,
		justifyContent: 'center',
		alignItems: 'center',
		alignSelf: 'center',
		width: 'auto',
		height: 'auto',
	};
	
	// write it to style
	createdProps[ 'style' ] = { ...style, ...callerStyle };
	
	createdProps[ 'fill' ] = color;
	createdProps[ 'color' ] = color;
	
	return createdProps;
}

export const renderMaterialCommunityIcon = ( name, props = {} ) => {
	
	return (
		<RenderIconBadge
			{ ...props }
			icon={(
				<MaterialCommunityIcons
					name={ name }
					{...createProps( props )}
				/>
			)}
		/>
	)
}

export const renderFontAwesomeIcon = ( name, props = {}, faStyle = FA5Style.regular ) => {
	switch( faStyle ){
		case FA5Style.regular:
			return (
				<RenderIconBadge
					{ ...props }
					icon={(
						<FontAwesome5
							name={ name }
							{...createProps( props )}
						/>
					)}
				/>
			)
			
		case FA5Style.solid:
			return (
				<RenderIconBadge
					{ ...props }
					icon={(
						<FontAwesome5
							solid
							name={ name }
							{...createProps( props )}
						/>
					)}
				/>
			)
			
		case FA5Style.light:
			return (
				<RenderIconBadge
					{ ...props }
					icon={(
						<FontAwesome5
							light
							name={ name }
							{...createProps( props )}
						/>
					)}
				/>
			)
			
		case FA5Style.brand:
			return (
				<RenderIconBadge
					{ ...props }
					icon={(
						<FontAwesome5
							brand
							name={ name }
							{...createProps( props )}
						/>
					)}
				/>
			)
	}
}

const RenderIconBadge = ( props ) => {
	const { icon, badge } = props;
	const badgeFontSize = _.get( props, 'badgeFontSize', 9 )
	
	const containerStyle = {
		position: 'absolute',
		right: 0,
		top: 0,
		backgroundColor: colorList.RED.primary,
		...props.badgeStyle
	};
	
	const textStyle = {
		fontSize: badgeFontSize,
		color: colorList.WHITE.primary
	};
	
	if( badge === undefined ) {
		return icon;
	}
	
	
	return (
		<View>
			{ icon }
			<ThemedBadge
				containerStyle={ containerStyle }
				textStyle={ textStyle }
				value={ props.badge }
			/>
		</View>
	);
}
